/* projects/speaker-platform/src/app/organisms/admin/speaker-edit-parameters/speaker-edit-parameters.component.scss */
.editparameters__recorddays {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1607843137);
  border-radius: 10px;
}
.editparameters__recorddays__day {
  text-align: center;
}
.editparameters__dangerzone {
  border: 2px solid #952626;
  border-radius: 8px;
  overflow: hidden;
}
.editparameters__dangerzone h6 {
  background-color: #FF7474;
  color: #952626;
  padding: 16px;
}
.editparameters__dangerzone__body {
  padding: 16px;
}
/*# sourceMappingURL=speaker-edit-parameters.component-FHRSK57R.css.map */
